import React, { Component } from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import moment from 'moment';
import MxVideoPlayer from 'mx-video-player';
import Timecode from 'mx-video-timecode';
import classNames from 'classnames';

import * as util from './util';
import {Config, LogoUrl} from '../../util';

class LiveVideoItem extends Component {
  constructor(props) {
    super(props);
    this.state = {
      info: '',
      url: '',
      live: false,
      videoCurrentTime: '',
      videoItem: props.videoItem,
      volumeFlag: false
    };

    this.startFromSec = 0;
    
    this.VIDEO_TIMER = undefined;

    this.handleOnLoadStart = this.handleOnLoadStart.bind(this);
    this.handleOnLoadedMetadata = this.handleOnLoadedMetadata.bind(this);
    this.handleOnPlay = this.handleOnPlay.bind(this);
    this.handleOnPause = this.handleOnPause.bind(this);
    this.handleOnEnded = this.handleOnEnded.bind(this);
    this.handleOnVolume = this.handleOnVolume.bind(this);
  }

  componentWillReceiveProps(nextProps, nextState){
      if(this.props.activeVideo !== nextProps.activeVideo){
        if(nextProps.activeVideo === nextProps.id){
          if(this.player) {
            this.player.dom.volume = 1;
          }
        }else {
          if(this.player) {
            this.player.dom.volume = 0;
          }
        }
      }else{
        if(this.player) {
          this.player.dom.volume = 0;
        }
      }
    
  }



  handleOnLoadStart(){
    if(this.player) this.player.dom.volume = 0;
  }
  handleOnLoadedMetadata() {
    const {videoItem} = this.state;
    if(!videoItem.live){
      this.setStartPosition(videoItem);
    }
  }
  handleOnPlay() {
    // this.displayCurrentTime();
  }
  handleOnPause () {
    // clearInterval(this.VIDEO_TIMER);
  }
  handleOnEnded(){
    // clearInterval(this.VIDEO_TIMER);
    const {
      videoCurrentTime,
      videoItem
    } = this.state;

    if(util.checkPlayContinously(videoCurrentTime, videoItem)) {

    }
  }
 
  handleOnVolume(e){
    if(this.player){
      const vdom = this.player.dom;
      this.props.handleMute(this.props.id, vdom.volume);
    }
  }
  

  setStartPosition(videoItem) {
    if(this.player){
      this.startFromSec = util.setStartFrom(videoItem);
      this.player.api.seek(this.startFromSec);
    }
  }
  displayCurrentTime(){
    // clearInterval(this.VIDEO_TIMER);
    const {start, live} = this.state.videoItem;
    // if(!live) {
      
    //   const startTime = moment(start, 'YYYYMMDDHHmmss').format('HH:mm:ss');
    //   const startArr = startTime.split(":");
    //   // const videoStartTime = Timecode.sec.tc2sec(startTime) - this.startFromSec;
    //   this.VIDEO_TIMER = setInterval(() => {
    //     // const currentTime = videoStartTime + Math.floor(this.player.api.currentTime);
    //     const timeStr = Timecode.fps.sec2tc(this.$player.api.currentTime);
    //     const timeRest = startArr[0] + ":" + timeStr.split(":").slice(1).join(":");
    //     this.setState({
    //       videoCurrentTime: timeRest//Timecode.sec.sec2tc(currentTime)
    //     });
    //   }, 100);
    // }
  }


  render() {
    const {
      startTimeSec,
      videoCurrentTime,
      videoInfo,
      videoItem
    } = this.state;

    let {
      id,
      videoTotalCount
    } = this.props;

    const {
      url, hls, airDate, live
    } = videoItem;
    // const channelImage = LogoUrl(videoItem.chname);
    const channelImage = videoItem.chName ? _.keyBy(Config.logoUrl, 'title')[videoItem.chName] : '';
    return (
      <div className={classNames("item", {
          "four_total" : videoTotalCount > 1 && videoTotalCount <= 4  // 채널 4개까지
        },{
          "six_total" : videoTotalCount > 4 && videoTotalCount <= 6  // 채널 6개까지
        },{
          "nine_total" : videoTotalCount > 6 && videoTotalCount <= 9  // 채널 9개까지
        },
        {
          "total" : videoTotalCount > 9  // 채널 9개 이상
        }
        )}>
        <div className="video">
          {(url || hls) ? <MxVideoPlayer
            ref={(i) => {this.player = i;}}

            debug={true}
            live={live}
            fullscreen={false}
            detection={true}
            alignCenter={true} // 가운데정렬
    
            autoplay={true}
            autoHide={true}
            id={id}
            className="chrome"
            playsinline='true'
            timecode='smtp' // 영상플레이어 frame 단위 이동
            src={url || hls}
            

            onLoadStart={this.handleOnLoadStart}
            onLoadedMetadata={this.handleOnLoadedMetadata}
            onPlay={this.handleOnPlay}
            onPause={this.handleOnPause}
            onEnded={this.handleOnEnded}
            onVolumeChange={this.handleOnVolume}
          /> : null}
        </div>
        <div className="info">
          <div>
            <img src={channelImage && channelImage.imgBlack} alt={channelImage && channelImage.title} />
          </div>
          {live ? <div className="live">LIVE</div> : <div className="time">{videoCurrentTime}</div>}
          <div className="date">{airDate}</div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    selectedMenu: state.selectedMenu,
  }
};

LiveVideoItem = connect(mapStateToProps)(LiveVideoItem);


export default LiveVideoItem;


// WEBPACK FOOTER //
// ./src/components/video/LiveVideoItem.js